// This file is generate automatically by NPM// Don't edit this fileimport {CalculatorFreelance} from '../../../templates/flexibles/calculator-freelance/calculator-freelance.js'
import {GridCountdownTimer} from '../../../templates/flexibles/grid-countdown-timer/grid-countdown-timer.js'
import {TabTutorial} from '../../../templates/flexibles/tab-tutorial/tab-tutorial.js'
import {Integrations} from '../../../templates/flexibles/integrations/integrations.js'
import {Header} from '../../../templates/flexibles/header/header.js'
import {TableOffer} from '../../../templates/flexibles/table-offer/table-offer.js'
import {Calculator} from '../../../templates/flexibles/calculator/calculator.js'
import {SliderTestimonials} from '../../../templates/flexibles/slider-testimonials/slider-testimonials.js'
import {PostsList} from '../../../templates/flexibles/posts-list/posts-list.js'
import {SliderLogo} from '../../../templates/flexibles/slider-logo/slider-logo.js'
import {PlotPricingAuto} from '../../../templates/flexibles/plot-pricing-auto/plot-pricing-auto.js'
import {FullForm} from '../../../templates/flexibles/full-form/full-form.js'
import {TabNavigation} from '../../../templates/flexibles/tab-navigation/tab-navigation.js'
import {BigSubmenu} from '../../../templates/flexibles/big-submenu/big-submenu.js'
import {PlotPricing} from '../../../templates/flexibles/plot-pricing/plot-pricing.js'
import {ProductFeatures} from '../../../templates/flexibles/product-features/product-features.js'

export let flexiblesController = {
  CalculatorFreelance: CalculatorFreelance,
  GridCountdownTimer: GridCountdownTimer,
  TabTutorial: TabTutorial,
  Integrations: Integrations,
  Header: Header,
  TableOffer: TableOffer,
  Calculator: Calculator,
  SliderTestimonials: SliderTestimonials,
  PostsList: PostsList,
  SliderLogo: SliderLogo,
  PlotPricingAuto: PlotPricingAuto,
  FullForm: FullForm,
  TabNavigation: TabNavigation,
  BigSubmenu: BigSubmenu,
  PlotPricing: PlotPricing,
  ProductFeatures: ProductFeatures
}